import { CertificacionI } from "interfaces/Certificacion";

export interface infoFecthCertificacionI {
  id: number | string;
  nombre: string;
  descripcion: string;
}

class Certificacion implements CertificacionI {
  id: number | string;
  nombre: string;
  descripcion: string;

  constructor(infoFetch: infoFecthCertificacionI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.descripcion = infoFetch.descripcion;
  }
}

export const makeCertificacion = (infoFetch: infoFecthCertificacionI) => {
  return new Certificacion(infoFetch);
};
